module.exports = __webpack_public_path__ + "img/icon_guide.c01e3cfd.png";